import { useRef, useEffect } from 'react';

// pulled from:
// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
